import { createSlice } from "@reduxjs/toolkit";
import i18n from "../../i18n/config";

const initialState = {
  language: "en",
};

const i18nSlice = createSlice({
  name: "i18n",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
      i18n.changeLanguage(action.payload); // ← MIGRATION TOTALE VERS REDUX
    },
  },
});

export const { setLanguage } = i18nSlice.actions;
export default i18nSlice.reducer;
